export default {
  Current: 'Vigente',
  InProgress: 'En proceso',
  CanceledWithApproval: 'Cancelado con aceptación',
  CanceledWithoutApproval: 'Cancelado sin aceptación',
  DeniedByCustomer: 'Rechazado por el cliente',
  CanceledExpiredTerm: 'Cancelado plazo vencido',
  NotCancellable: 'No cancelable',
};
